// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__WzW2M","code":"Error_code__VQT3Z","image":"Error_image__nBj8S","header":"Error_header__Q3gb3","message":"Error_message__uy2kT"};